// export const validateFields = (tabData, requiredFields, customErrorMessage) => {
//     const errors = {};
  
//     requiredFields.forEach(field => {
//       if (!tabData[field]) {
//         const fieldName = field.replace(/([A-Z])/g, ' $1').trim(); 
//         const capitalizedFieldName = fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
//         errors[field] = customErrorMessage ? customErrorMessage(capitalizedFieldName) : `Please Fill ${capitalizedFieldName}, It's Required.`;
//       }
//     });
  
//     return errors;
//   };
  
import { jwtDecode } from "jwt-decode";
import { AuthService } from "../../service/AuthService";
import { VendorService } from "../../service/VendorService";
import { ROLE_NAMES } from "../../constants/constants";


export const validateFields = (tabData, requiredFields, customErrorMessage) => {
  const errors = {};

  requiredFields.forEach((field) => {
    if (!tabData[field] || tabData[field].trim() === "") {
      const fieldName = field.replace(/([A-Z])/g, " $1").trim();
      const capitalizedFieldName =
        fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
      errors[field] = customErrorMessage
        ? customErrorMessage(capitalizedFieldName)
        : `Please fill ${capitalizedFieldName}, it's required.`;
    }
  });

  const nameValidationFields = ["city" ,"district","accountName" ,"clientName","clientContactPerson"];
  nameValidationFields.forEach((field) => {
    if (tabData[field] && !/^[a-zA-Z\s]+$/.test(tabData[field])) {
      errors[field] = `${field.replace(/([A-Z])/g, " $1")} should contain only letters and spaces.`;
    }
  });
 
  // if (tabData.postalCode && !/^\d{6}$/.test(tabData.postalCode)) {
  //   errors.postalCode = " Postal Code must be 6 digits.";
  // }

  // if (tabData.mobileNo && !/^\d{10}$/.test(tabData.mobileNo)) {
  //   errors.mobileNo = "Mobile number must be exactly 10 digits.";
  // }
  // const phoneFields = ["mobileNo", "telephone", "primaryPhone", "clientMobilePhone"];

  const phoneFields = ["mobileNo", "clientMobilePhone"];

  phoneFields.forEach((field) => {
    if (tabData[field] && !/^\+?[0-9]{7,15}$/.test(tabData[field])) {
      errors[field] = `${field.replace(/([A-Z])/g, " $1")} must be a valid phone number.`;
    }
  });

const numberFields = ["fax", "clientNumberOfYears"];

numberFields.forEach((field) => {
  if (tabData[field] && tabData[field].trim() !== "" && !/^\d+$/.test(tabData[field])) {
    errors[field] = `${field.replace(/([A-Z])/g, " $1")} must contain only numbers.`;
  }
});


  const emailFields = ["email", "primaryEmail"];

  emailFields.forEach((field) => {
    if (!tabData[field]) {
      return;
    }

    if (field === "primaryEmail") {
      const emails = tabData[field]
        .split(",")
        .map((email) => email.trim())
        .filter(Boolean);
      const hasInvalid = emails.some(
        (email) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
      );
      if (hasInvalid) {
        errors[field] = `${field.replace(/([A-Z])/g, " $1")} is invalid.`;
      }
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(tabData[field])) {
      errors[field] = `${field.replace(/([A-Z])/g, " $1")} is invalid.`;
    }
  });

  return errors;
};

/**
 * Check if user has specific permission
 * @param {Object} permissionsObj - Permissions object
 * @param {string} module - Module name (e.g., 'PR', 'VENDORS')
 * @param {string} action - Action to check (e.g., 'VIEW', 'EDIT')
 * @returns {boolean} - true if permission exists, false otherwise
 */
export const hasPermission = (module, action) => {
  const permissionsObj = AuthService.currentUser()?.permissions;
  console.log("Checking permission for module:", module, "action:", action, permissionsObj);
  const modulePermissions = permissionsObj?.[module];
  return Array.isArray(modulePermissions) && modulePermissions.includes(action.toUpperCase());
};

/**
 * Normalize API `role` fields that may be a string, number, or nested object (e.g. `{ name: "VENDOR" }`).
 * @param {unknown} role
 * @returns {string}
 */
const isBlankNamePart = (v) => {
  if (v == null) return true;
  const t = String(v).trim();
  if (!t) return true;
  if (/^null$/i.test(t)) return true;
  return false;
};

/**
 * Pretty-print login/user id when full name is unavailable (email local part or plain id).
 */
export const formatUserIdForDisplay = (raw) => {
  if (raw == null || raw === "") return "User";
  const s = String(raw).trim();
  if (!s) return "User";
  const local = s.includes("@") ? s.split("@")[0] : s;
  const words = local
    .replace(/[._-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .filter(Boolean);
  if (!words.length) return "User";
  return words
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
};

/**
 * Display name: first / middle / last from user object, else JWT `UserFullName`, else formatted userid/email.
 * Accepts stored login user (incl. `token`) or API user row.
 */
export const getUserDisplayName = (user) => {
  if (!user || typeof user !== "object") return "User";

  const first = user.firstname ?? user.firstName;
  const mid = user.middlename ?? user.middleName;
  const last = user.lastname ?? user.lastName;
  const parts = [first, mid, last].filter((p) => !isBlankNamePart(p));
  if (parts.length) {
    return parts.map((p) => String(p).trim()).join(" ");
  }

  let fullJwt = null;
  try {
    if (user.token) {
      const d = jwtDecode(user.token);
      fullJwt = d.UserFullName || d.userFullName || null;
    }
  } catch {
    /* ignore */
  }
  if (fullJwt && String(fullJwt).trim()) {
    const cleaned = String(fullJwt)
      .replace(/\bnull\b/gi, " ")
      .replace(/\s+/g, " ")
      .trim();
    if (cleaned) return cleaned;
  }

  return formatUserIdForDisplay(user.userid ?? user.email ?? user.username ?? "");
};

export const getRoleKeyString = (role) => {
  if (role == null || role === '') return '';
  if (typeof role === 'object' && !Array.isArray(role)) {
    const inner =
      role.name ??
      role.roleName ??
      role.role ??
      role.label ??
      role.type;
    if (inner != null && inner !== role) return getRoleKeyString(inner);
    return '';
  }
  return String(role).trim();
};

/** True when the session user's active role is SUPER_ADMIN. */
export const isSuperAdminRole = (user = AuthService.currentUser()) =>
  getRoleKeyString(user?.role).toUpperCase() === ROLE_NAMES.SUPER_ADMIN;

/**
 * Convert role name from "ROLE_NAME" format to "Role Name" format
 * @param {string} roleName - Role name in uppercase with underscores
 * @returns {string} - Formatted role name
 */
export const formatRoleName = (roleName) => {
  const s = getRoleKeyString(roleName);
  if (!s) return '';

  // Replace underscores with spaces and convert to title case
  return s
    .replace(/_/g, ' ')
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const normalizeDefaultRoleId = (roleIdRaw) => {
  if (roleIdRaw == null || roleIdRaw === "") return "";
  const s = String(roleIdRaw).trim();
  if (!s) return "";
  if (s.includes(",")) return s.split(",")[0].trim();
  return s;
};

/** True when session `role` is missing or only a numeric id (not a role code/name). */
export const sessionRoleNeedsNameResolve = (role) => {
  const key = getRoleKeyString(role);
  if (!key) return true;
  return /^\d+$/.test(key);
};

/**
 * Resolve role name from roleId for the session user (login / refresh).
 * Header role switch already sets `role`; initial login often only has roleId.
 */
export const resolveSessionRoleName = async (user) => {
  if (!user || typeof user !== "object") return user;
  if (!sessionRoleNeedsNameResolve(user.role)) return user;

  const roleIdRaw = normalizeDefaultRoleId(user.roleId);
  const roleIdNum = Number(roleIdRaw);
  if (!Number.isFinite(roleIdNum) || roleIdNum <= 0) return user;

  try {
    const res = await VendorService.getRoles({
      id: roleIdNum,
      page: 0,
      size: 1,
    });
    const name = res?.result?.[0]?.name;
    if (!name) return user;
    return { ...user, roleId: roleIdNum, role: name };
  } catch (err) {
    console.error("Failed to resolve session role name:", err);
    return user;
  }
};

export const fetchPermissionsAndUpdateUser = async (user) => {
  try {
    const roleId = normalizeDefaultRoleId(user?.roleId);
    const permissionsResponse = await VendorService.listPermissions({
      roleId,
      page: 0,
      size: 10000,
    });

    const rows = Array.isArray(permissionsResponse?.result)
      ? permissionsResponse.result
      : Array.isArray(permissionsResponse?.data)
        ? permissionsResponse.data
        : [];
    const permissions = {};

    rows.forEach((item) => {
      const moduleName =
        item?.module?.name ||
        item?.moduleName ||
        (typeof item?.module === "string" ? item.module : "");
      if (!moduleName) return;

      let parsedPermissions = item.permissions;
      if (typeof parsedPermissions === "string") {
        try {
          parsedPermissions = JSON.parse(parsedPermissions);
        } catch (error) {
          console.error("Error parsing permission item:", error);
          return;
        }
      }
      if (!Array.isArray(parsedPermissions)) return;
      const current = permissions[moduleName];
      if (!current || parsedPermissions.length > current.length) {
        permissions[moduleName] = parsedPermissions;
      }
    });

    if (!Object.keys(permissions).length && user?.permissions) {
      return user;
    }

    const updatedUser = { ...user, permissions };
    localStorage.setItem("user", JSON.stringify(updatedUser));
    return updatedUser;
  } catch (err) {
    console.error("Failed to fetch permissions:", err);
    return user;
  }
};

/**
 * Check if the current user's role is vendor
 * @returns {boolean} - true if user role is vendor, false otherwise
 */
export const isVendorRole = () => {
  const currentUser = AuthService.currentUser();
  const key = getRoleKeyString(currentUser?.role).toUpperCase();
  return key === "VENDOR";
};
